<template>
  <v-row no-gutters align-content="center" class="left_menu__prepend left_menu__prepend--first">
    <v-col cols="12" align="center" class="left_menu__prepend__logo overflow-visible">
      <v-img
          :width="240"
          :src="logo"
          alt="logo"
          style="cursor: pointer"
          @click="navigateTo()"
      />
    </v-col>
  </v-row>
  <v-row no-gutters align-content="center" class="left_menu__prepend left_menu__prepend--second">
    <v-col v-if="member" cols="12" class="left_menu__prepend__name">
      <span v-if="member.type">
        {{ member.last_name }} {{ member.name }}<br/>
        {{ member.middle_name }}
      </span>
      <span v-else>
        {{ member.email }}
      </span>
    </v-col>
    <v-col v-if="member" cols="12" align="center">
      <div class="left_menu__prepend__btn">
        <span>{{ checkType(member.type) }}</span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import logo from "@/assets/img/logo.svg"
import pa_names from "@/modules/personal_account/routers/names"
import { mapActions, mapGetters } from "vuex"

export default {
  name: 'LeftMenuPrepend',
  data () {
    return {
      logo: logo,
    }
  },
  computed: {
    pa_names: () => pa_names,
    ...mapGetters({
      member: 'personal_account/users/getUserInfo',
      isLoadingMembers: 'personal_account/users/isLoadingUsers',
    }),
  },
  methods: {
    ...mapActions({
      loadMembers: 'personal_account/users/loadUserInfo',
    }),
    navigateTo () {
      if (window.scrollY !== 0) {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        })
      }
      this.$router.push({ name: pa_names.MAIN })
    },
    checkType (value) {
      if (value === "science") {
        return 'Молодой ученый'
      } else if (value === "postgraduate") {
        return 'Аспирант'
      } else if (value === "student") {
        return 'Студент'
      } else if (value === "schoolchild") {
        return 'Школьник'
      } else {
        return 'Отсутствует тип'
      }
    },
    loadData (url = undefined) {
      this.loadMembers({
        url: url,
        finalizer: () => {},
        catcher: () => {}
      })
    },
  },
  created () {
    this.loadData()
  }
}

</script>

<style scoped lang="scss">
.left_menu__prepend__logo {
  position: relative;
  text-align: center;
  text-align: -webkit-center;
}

.left_menu__prepend {
  width: 390px;

  &--first {
    height: 200px;
    background-color: #313743;
  }

  &--second {
    height: 100px;
    margin-top: 50px;
    margin-bottom: 50px;
  }
}

.left_menu__prepend__name {
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
  color: white;
}

.left_menu__prepend__btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  background-color: #376FFE;
  color: white;
  font-size: 14px;
  font-weight: 600;
  width: 190px;
  height: 32px;
  border-radius: 50px;
}

@media screen and (max-width: 1560px) {
  .left_menu__prepend {
    &--first {
      height: 150px;
    }

    &--second {
      height: 100px;
      margin-top: 30px;
    }
  }
}
</style>
